import React from 'react';
import { FulfillmentType } from 'src/components/oneCorp/features/MealCredit/utils/EnterpriseManageMealCreditsPage.utils';
import {
  DeliveryInfo,
  IDeliveryInfoProps,
} from 'src/components/enterprise/features/OrderHistory/OrderReceipt/FulfillmentInfo/DeliveryInfo';
import {
  IPickupInfoProps,
  PickupInfo,
} from 'src/components/enterprise/features/OrderHistory/OrderReceipt/FulfillmentInfo/PickupInfo';

export interface IFulfillmentInfoProps {
  type: FulfillmentType;
  date: string;
}

export function FulfillmentInfo(props: IFulfillmentInfoProps): JSX.Element {
  const { type } = props;
  return type === FulfillmentType.DELIVERY ? (
    <DeliveryInfo {...(props as IDeliveryInfoProps)} />
  ) : (
    <PickupInfo {...(props as IPickupInfoProps)} />
  );
}
